// extracted by mini-css-extract-plugin
module.exports = {"stockWrap":"StockPrice_stockWrap__TlTVI","stockItem":"StockPrice_stockItem__7F3uI","textMain":"StockPrice_textMain__lK4pq","textSecond":"StockPrice_textSecond__dzNol"};